module.exports = __webpack_public_path__ + "static/media/seaweed.63219082.png";